import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAudio } from "../Contexts/AudiosContext";
import imgdownload from "../assets/audioPlayer/img/download.svg";
import imgrepeat from "../assets/audioPlayer/img/whiterepeat.svg";
import imgback from "../assets/audioPlayer/img/whiteprevious.svg";
import imgforward from "../assets/audioPlayer/img/whitenext.svg";
import imgclose from "../assets/audioPlayer/img/whitecancel.svg";
import imginfo from "../assets/audioPlayer/img/info.svg";
import imgmaximize from "../assets/audioPlayer/img/maximize.svg";
import imgpause from "../assets/audioPlayer/img/Pause.svg";
import imgplay from "../assets/audioPlayer/img/bgorangepause.svg";
import "../Styles/Audios.css";
import { ProgressBar } from "react-bootstrap";

const AudioPlayer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    currentAudio,
    isMinimise,
    setIsMinismise,
    close,
    next,
    prev,
    setAudioInfoDialog,
    repeat,
  } = useAudio();
  const refAudio = React.useRef<HTMLAudioElement>(null);

  useEffect(() => {
    if (!refAudio.current || !currentAudio) return;
    // If the user has previously interacted with audio on this site,
    // some browsers allow autoplay with sound. Persist that state in
    // localStorage (`hasInteractedWithAudio`). Try unmuted play first
    // when available; otherwise fall back to a muted autoplay attempt.
    const userInteracted = localStorage.getItem("hasInteractedWithAudio") === "1";
    const tryPlayUnmuted = async () => {
      try {
        if (!refAudio.current) return;
        // ensure not muted when attempting unmuted play
        refAudio.current.muted = false;
        await refAudio.current.play();
        return true;
      } catch (err) {
        return false;
      }
    };

    const tryPlayMuted = async () => {
      try {
        if (!refAudio.current) return false;
        refAudio.current.muted = true;
        await refAudio.current.play();
        // try to unmute shortly after if autoplay succeeded muted
        setTimeout(() => {
          try {
            if (refAudio.current) refAudio.current.muted = false;
          } catch (e) {}
        }, 500);
        return true;
      } catch (err) {
        return false;
      }
    };

    (async () => {
      if (userInteracted) {
        const ok = await tryPlayUnmuted();
        if (!ok) {
          // fallback to muted autoplay if unmuted attempt fails
          await tryPlayMuted();
        }
      } else {
        // No prior interaction: try muted autoplay first (more likely to succeed)
        const ok = await tryPlayMuted();
        if (!ok) {
          // attempt unmuted as last resort
          await tryPlayUnmuted();
        }
      }
    })();
  }, [currentAudio]);

  const [cTime, setCTime] = React.useState(0);
  const [aLength, setALength] = React.useState(0);
  const [playing, setPlaying] = React.useState(false);

  const [cardWidth, setcardWidth] = useState(window.innerWidth);
  window.addEventListener("resize", () => {
    setcardWidth(window.innerWidth);
  });

  function formatCurrentTime(seconds: any) {
    var minutes: any = Math.floor(seconds / 60);
    var remainingSeconds: any = Math.floor(seconds % 60);
    if (remainingSeconds < 10) {
      remainingSeconds = "0" + remainingSeconds;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    return minutes + ":" + remainingSeconds;
  }

  function formatLastMinuteAndSecond() {
    var lastMinute: any = Math.floor(aLength / 60);
    var lastSeconds: any = Math.floor(aLength % 60);
    if (lastSeconds < 10) {
      lastSeconds = "0" + lastSeconds;
    }
    if (lastMinute < 10) {
      lastMinute = "0" + lastMinute;
    }
    return lastMinute + ":" + lastSeconds;
  }
  function onLoadedMetadata(event: any) {
    setALength(event.target.duration);
  }
  return (
    <div className="">
      {currentAudio?.id ? (
        <div
          className="playaudio backcolor music-player"
          style={{ color: "white", fontSize: "16px" }}
          title={currentAudio?.name}
        >
          <div className="column" style={{ width: "38%", textAlign: "center" }}>
            {currentAudio == null ? (
              "no record found"
            ) : (
              <div>
                <audio
                  // controls
                  ref={refAudio}
                  id={`audio-${currentAudio.id}`}
                  autoPlay
                  src={
                    currentAudio.audioUrl != null
                      ? currentAudio.audioUrl
                      : currentAudio.pravachanUrl
                  }
                  onPlay={() => {
                    setPlaying(true);
                    try { localStorage.setItem("hasInteractedWithAudio", "1"); } catch (e) {}
                  }}
                  onPause={() => {
                    setPlaying(false);
                  }}
                  onDurationChange={(e) => {
                    setALength(e.currentTarget.duration);
                  }}
                  onLoadedMetadata={onLoadedMetadata}
                  onTimeUpdate={(e) => {
                    setCTime(e.currentTarget.currentTime);
                    if (
                      e.currentTarget.duration === e.currentTarget.currentTime
                    ) {
                      next();
                    }
                  }}
                  onLoad={(e: any) => (e.target.currentTime = 0)}
                />
                
                {cardWidth < 700 ? (
                  <div style={{fontFamily: 'ChanakyaUni', fontSize: '22px'}}>
                    {currentAudio?.name != null && currentAudio.name.length > 20
                      ? currentAudio.name.slice(0, 15) + "..."
                      : currentAudio?.name}
                  </div>
                ) : (
                  <div style={{fontFamily: 'ChanakyaUni', fontSize: '22px'}}>
                    {currentAudio?.name != null && currentAudio.name.length > 70
                      ? currentAudio.name.slice(0, 50) + "..."
                      : currentAudio?.name}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="column">
            <button
              className="backcolor"
              onClick={() => {
                setAudioInfoDialog();
              }}
            >
              <img
                alt="imginfo"
                src={imginfo}
                title="information"
                width="30px"
              />
            </button>
          </div>
          <div
            className="column"
            style={{ marginRight: "2px", marginLeft: "2px" }}
          >
            <a
              id="download"
              title="Download"
              href={
                currentAudio != null
                  ? currentAudio.audioPath != null
                    ? currentAudio.audioPath + "&download_attachment=true"
                    : currentAudio.pravachanPath + "&download_attachment=true"
                  : "no record found"
              }
            >
              <img
                alt="imgdownload"
                src={imgdownload}
                title="download"
                width="30px"
              />
            </a>
          </div>
          <div className="column">
            <button
              className="backcolor"
              onClick={() => {
                repeat();
              }}
            >
              <img
                alt="imgrepeat"
                src={imgrepeat}
                title="repeat"
                width="30px"
              />
            </button>
          </div>

          <div className="column">
            <button
              className="backcolor"
              onClick={() => {
                prev();
              }}
            >
              <img alt="imgback" src={imgback} title="prev" width="30px" />
            </button>
          </div>

          <div className="column">
            {playing ? (
              <button
                className="backcolor"
                onClick={() => {
                  refAudio.current?.pause();
                }}
              >
                <img alt="imgPse" src={imgpause} title="pause" width="40px" />
              </button>
            ) : (
              <button
                className="backcolor"
                onClick={() => {
                  // mark that the user has explicitly interacted with audio
                  try { localStorage.setItem("hasInteractedWithAudio", "1"); } catch (e) {}
                  refAudio.current?.play();
                }}
              >
                <img alt="imgPse" src={imgplay} title="play" width="40px" />
              </button>
            )}
          </div>

            
          <div className="column">
            <button
              className="backcolor"
              onClick={() => {
                next();
              }}
            >
              <img
                alt="imgforward"
                src={imgforward}
                title="next"
                width="30px"
              />
            </button>
          </div>

          <div
            className="column"
            style={{
              padding: "5px 15px 5px 15px",
              display: `${cardWidth > 767 ? "block" : "none"}`,
            }}
          >
            <span id="time">{formatCurrentTime(cTime)}</span>
          </div>
          <div
            className="column"
            style={{
              width: "30%",
              display: `${cardWidth > 767 ? "block" : "none"}`,
            }}
          >
            <ProgressBar
              variant="white"
              color="orange"
              now={cTime}
              min={0}
              max={aLength}
              style={{
                height: "6px",
                backgroundColor: "#e48c02",
              }}
              onClick={(e: any) => {
                var mouseX = e.clientX;
                var barX = e.target.offsetLeft;
                let distanceX = mouseX - barX;
                let total = e.currentTarget.offsetWidth;
                let timePerPixel = aLength / total;
                let currentTime = distanceX * timePerPixel;
                if (refAudio.current)
                  refAudio.current.currentTime = currentTime;
              }}
            />
          </div>
          <div
            className="column"
            style={{
              paddingLeft: "15px",
              display: `${cardWidth > 767 ? "block" : "none"}`,
            }}
          >
            <span id="total-time">{formatLastMinuteAndSecond()}</span>
            <span id="totalCaltime" style={{ display: "none" }}>
              0
            </span>
          </div>
          <div className="column">
            <button
              className="backcolor"
              style={isMinimise ? { display: "block" } : { display: "none" }}
              onClick={() => {
                setIsMinismise(false);
                const routeType = localStorage.getItem("type") === "pravachans" ? "pravachans" : "audios";
                const slug = currentAudio?.slug || window.location.pathname.split("/").filter(Boolean).pop() || currentAudio?.id;
                navigate(`/${routeType}/${slug}`, {
                  state: {
                    audioId: currentAudio?.id,
                    audioslug: currentAudio?.slug,
                  },
                });
              }}
            >
              <img
                alt="imgmaximize"
                src={imgmaximize}
                title="maximize"
                width="30px"
                style={{ marginLeft: "10px" }}
              />
            </button>
          </div>

          <div
            className="column"
            style={isMinimise ? { display: "block" } : { display: "none" }}
          >
            <button
              className="backcolor"
              onClick={() => {
                close();
              }}
            >
              <img alt="imgclose" src={imgclose} title="close" width="30px" />
            </button>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
export default AudioPlayer;
